import avi from '@/assets/file-icons/avi-svgrepo-com.svg'
import csv from '@/assets/file-icons/csv-svgrepo-com.svg'
import doc from '@/assets/file-icons/doc-svgrepo-com.svg'
import gif from '@/assets/file-icons/gif-svgrepo-com.svg'
import jpg from '@/assets/file-icons/jpg-svgrepo-com.svg'
import json from '@/assets/file-icons/json-svgrepo-com.svg'
import mov from '@/assets/file-icons/mov-svgrepo-com.svg'
import mpeg from '@/assets/file-icons/mpeg-svgrepo-com.svg'
import pdf from '@/assets/file-icons/pdf-svgrepo-com.svg'
import ppt from '@/assets/file-icons/ppt-svgrepo-com.svg'
import txt from '@/assets/file-icons/txt-svgrepo-com.svg'
import mp3 from '@/assets/file-icons/wav-svgrepo-com.svg'
import wmv from '@/assets/file-icons/wmv-svgrepo-com.svg'
import xls from '@/assets/file-icons/xls-svgrepo-com.svg'
import xml from '@/assets/file-icons/xml-svgrepo-com.svg'

export const formatToFile = new Map<string, string>([
  ['avi', avi],
  ['csv', csv],
  ['doc', doc],
  ['docx', doc],
  ['gif', gif],
  ['jpg', jpg],
  ['json', json],
  ['mov', mov],
  ['mp3', mp3],
  ['mp4', mpeg],
  ['mpeg', mpeg],
  ['pdf', pdf],
  ['png', jpg],
  ['ppt', ppt],
  ['pptx', ppt],
  ['txt', txt],
  ['wmv', wmv],
  ['xls', xls],
  ['xlsx', xls],
  ['xml', xml],
])
